import React from "react";

const IconDIners = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fillRule="nonzero"
                style={{fill: props?.iconFill}}
                d="M11.27 7.414a4.577 4.577 0 1 0 0 9.155 4.577 4.577 0 0 0 0-9.155m-1.039 7.284a2.905 2.905 0 0 1-1.862-2.707 2.91 2.91 0 0 1 1.862-2.708zm2.077.001V9.283a2.905 2.905 0 0 1 1.864 2.708 2.9 2.9 0 0 1-1.864 2.708M22 4H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2m-9.444 13H11.26c-2.767.013-5.043-2.228-5.043-4.956C6.216 9.062 8.492 7 11.259 7h1.296c2.734 0 5.229 2.061 5.229 5.043 0 2.728-2.495 4.957-5.228 4.957">
            </path>
        </svg>
    )
};

export default IconDIners;
